import type { SongMusicVideoSummary } from 'fym-shared/src/music24/musicVideoApi';

/**
 * What the music video field shows (design music-video g1, g2):
 * - `none`: no music video → "Add your video", "Make one".
 * - `youtube`: a linked YouTube video → "Open on YouTube", "Change".
 * - `file`: an uploaded file → "Replace", "Download".
 * - `made`: a video made in the editor → "Edit the video", "Replace with a file".
 * - `making`: the editor makes it now (queued, planning, rendering).
 * - `failed`: the newest made version failed and no ready one stays.
 */
export type MusicVideoFieldState = 'none' | 'youtube' | 'file' | 'made' | 'making' | 'failed';

/** The state of the field from `song.musicVideo` (spec 2026-10-09 §3.2). Pure. */
export function musicVideoFieldState(summary: SongMusicVideoSummary | null | undefined): MusicVideoFieldState {
  if (summary === null || summary === undefined) {
    return 'none';
  }
  if (summary.source === 'youtube') {
    return 'youtube';
  }
  if (summary.status === 'failed') {
    return 'failed';
  }
  if (summary.status !== 'ready') {
    return 'making';
  }
  return summary.source === 'upload' ? 'file' : 'made';
}

/** True when the field plays the file in the page (an upload or a made video with a file). Pure. */
export function playsInline(summary: SongMusicVideoSummary | null | undefined): boolean {
  return summary !== null && summary !== undefined && summary.status === 'ready' && summary.fileAvailable;
}
